import React from "react";
import "./CallToAction.css";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

function CallToAction() {
  return (
    <div className="cta__holder">
        
      <div className="right__section__cta">
        <h3 className="cta__header">Wat Else ?</h3>
        <h1 className="cta__header1"></h1>

        <div className="call__to__action">
          <div className="cta__heading">
            <p>Learn More About The wellBeing foundation</p>
          </div>
        </div>

      </div>

        <div className="cta__button">
          <Link to="wellbeingfoundation.org">
            <button className="btn__visit">VISIT TWF</button>
          </Link>

          <Link to="https://www.pexels.com/search/sustainable%20fashion/">
            <button className="btn__callUs">CONTACT US</button>
          </Link>
        </div>

    </div>
  );
}

export default CallToAction;
